import FormalPrisma from "./FormalPrisma";
import { datosEjemplo } from "./sampleData";
import { paletas } from "./paletas";

export const definicion = {
  id: "formal-prisma",
  tipoEvento: "formal",
  tipoEtiqueta: "Evento formal",
  nombre: "Prisma",
  descripcion:
    "Diseño estructurado para capacitaciones, reuniones y conferencias: título protagonista, chips de datos clave, agenda tipo tabla y grilla de disertantes. Sobrio y claro.",
  miniatura: datosEjemplo.fotos.portada,
  miniaturas: {
    corporativo: "/miniaturas/formal-prisma-corporativo.jpg",
    burdeos: "/miniaturas/formal-prisma-burdeos.jpg",
    bosque: "/miniaturas/formal-prisma-bosque.jpg",
  },
  paletas,
  datosEjemplo,
  Componente: FormalPrisma,
};
